import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { take } from 'rxjs';
import { UserAreaRole } from '../../../models/user-area.model';
import { AlertService } from '../../../services/alert.service';
import { UserAreaService } from '../../../services/user-area.service';
import { fieldRequired } from '../../../utils/form.utils';

@Component({
  selector: 'app-invite-member-area',
  templateUrl: './invite-member-area.component.html',
  styleUrl: './invite-member-area.component.scss',
  standalone: false,
})
export class InviteMemberAreaComponent {
  public form: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    role: new FormControl<UserAreaRole>('MEMBER', [Validators.required]),
  });

  public roleOptions: SelectItem<UserAreaRole>[] = [
    { label: 'Mitglied', value: 'MEMBER' },
    { label: 'Admin', value: 'ADMIN' },
  ];

  fieldRequired = fieldRequired;

  public isLoading = false;
  public areaId: number;

  constructor(
    private userAreaService: UserAreaService,
    private alertService: AlertService,
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.areaId = this.config.data?.areaId;
  }

  onInvite(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    this.userAreaService
      .inviteUser({
        area_id: this.areaId,
        userEmail: this.form.get('email')?.value,
        role: this.form.get('role')?.value,
      })
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.alertService.showSuccessAlert('Einladung versendet.');
          this.dialogRef.close(true);
          this.form.reset();
        },
        error: err => {
          this.isLoading = false;
          this.alertService.showErrorAlert(
            err?.message || 'Einladung fehlgeschlagen.'
          );
        },
      });
  }

  onCancel(): void {
    this.dialogRef.close(false);
    this.form.reset();
  }
}
